import { render, staticRenderFns } from "./DashboardNuevo.vue?vue&type=template&id=244e030d&scoped=true"
import script from "./DashboardNuevo.vue?vue&type=script&lang=js"
export * from "./DashboardNuevo.vue?vue&type=script&lang=js"
import style0 from "./DashboardNuevo.vue?vue&type=style&index=0&id=244e030d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244e030d",
  null
  
)

export default component.exports